export default {
  noSignalsSelected: 'No signals are selected. Use Presets or Expert View mode to choose signals.',
};
